import { useState } from "react";
import { Col, Row } from "reactstrap";
import Toast from "../../helpers/Toast";
import ButtonComponent from "../ButtonComponent";
import { useIntl } from "react-intl";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import InputComponent from "../InputComponent";
import SearchSelectComponent from "../SearchSelectComponent";
import { GetClientAssistanceCreateRequestDTO } from "../../models/Assistance/GetClientAssistanceCreateRequestDTO";
import { ClientService } from "../../services/ClientService";
import { AssistanceService } from "../../services/AssistanceService";
import { SelectItemsProps } from "../ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import { UpdateClientInAssistanceAndEquipmentDTO, UpdateClientInAssistanceAndEquipmentDTOSchema } from "../../models/Assistance/UpdateClientInAssistanceAndEquipmentDTO";
import { EquipmentService } from "../../services/EquipmentService";
import { CheckIfOwnerRequestDTO } from "../../models/Equipment/CheckIfOwnerRequestDTO";
import { NullableType } from "joi";
import { useMobile } from "../Layout/UseResponsive";

interface UpdateClientComponentProps {
    equipmentErpId: string | null,
    equipmentName: string | null,
    equipmentSerialNumber: string | null,
    clientSelected: SelectItemsProps | null;
    equipmentModel: string | null,
    equipmentBrand: string | null,
    assistanceId: number | null,
    loading: boolean,    
    setClientSelected: (client: SelectItemsProps | null) => void;
    isActiveSearchByCarPlate: boolean;
    equipmentCarPlate: string | null;
}

export default function UpdateClientComponent(props: UpdateClientComponentProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);
    const [newClientSelected, setNewClientSelected] = useState<SelectItemsProps | null>(null);
    const [isClientOwner, setIsClientOwner] = useState<NullableType<boolean>>(null);

    const isMobile = useMobile();
    
    const intl = useIntl();
    const clientService = new ClientService();
    const assistanceService = new AssistanceService();
    const equipmentService = new EquipmentService();


    const handleClientChange = async (clientInput: SelectItemsProps | null) => {
        setIsEditButtonLoading(true);
        setNewClientSelected(clientInput);        

        if (clientInput === null || clientInput.value === null || clientInput.value === "" || clientInput.value === undefined) {
            setIsClientOwner(null);
            setIsEditButtonLoading(false);
            return;
        }

        if (clientInput?.value !== props.clientSelected?.value) {

            var data: CheckIfOwnerRequestDTO = {
                clientErpId: clientInput?.value,
                equipmentErpId: props.equipmentErpId
            }
            
            var response = await equipmentService.CheckIfClientIsEquipmentOwner(data);
            if (response.success === false) {
                Toast.Show("error", response.message);
                setIsEditButtonLoading(false);
                return;
            }
            setIsClientOwner(response.obj);
        }
        setIsEditButtonLoading(false);
    }

    const GetByClient = async (value: string): Promise<SelectItemsProps[]> => {
        var data: GetClientAssistanceCreateRequestDTO = {
            clientSearch: value,
        };

        var response = await clientService.GetClientAssistanceCreate(data);
        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        return response.obj.map((element: any) => ({
            value: element.clientErpId,
            label: element.clientName,
        }));
    };
    const calcSizeByItems = props.isActiveSearchByCarPlate ? 3 : 4;

    const updateClient = async () => {

        setIsEditButtonLoading(true);
        var sendData: UpdateClientInAssistanceAndEquipmentDTO = {
            clientErpId: newClientSelected?.value,
            equipmentErpId: props.equipmentErpId,
            assistanceId: props.assistanceId
        }        

        var requestValidate = await UpdateClientInAssistanceAndEquipmentDTOSchema.validate(sendData);
        if (requestValidate.error != null) {
            var message = requestValidate.error!.details[0].message;
            setIsEditButtonLoading(false);
            Toast.Show("error", message);
            return;
        }

        //se o pedido ao backend for executa com sucesso entao envia para o componente pai
        const response = await assistanceService.UpdateClientInAssistanceAndEquipment(sendData);
        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsEditButtonLoading(false);
            return;
        }

        props.setClientSelected(newClientSelected);
        setIsEditButtonLoading(false);
        setIsOpen(false);
        Toast.Show("success", intl.formatMessage({ id: "UpdateClientComponent.Toast.Success" }));

    };

    return (
        <>
            <ButtonComponent
                onClick={() => { setIsClientOwner(null); setNewClientSelected(null); setIsOpen(true); }}
                className="enteraccount"
                style={{ width: "100%", marginBottom: "8px" }}
                text={intl.formatMessage({ id: "UpdateClientComponent.Edit" })}
                disabled={props.loading}
                loading={props.loading}
            />
            
            <Dialog open={isOpen} fullWidth={true} maxWidth="md"
                onClose={() => setIsOpen(false)}>
                <DialogTitle>{intl.formatMessage({ id: "UpdateClientComponent.Dialog.Title" })}</DialogTitle>
                <DialogContent>
                    <Row>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            type={"text"}
                            style={{ width: "100%", height: "43px" }}
                            label={intl.formatMessage({ id: "UpdateClientComponent.Content.CurrentClientName" })}
                            value={props.clientSelected?.label} readOnly={true} />

                        <SearchSelectComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            label={intl.formatMessage({ id: "UpdateClientComponent.Content.NewClientName" })}
                            loadOptions={GetByClient}
                            onChange={(e) => handleClientChange(e)}
                            value={newClientSelected}
                            style={{ width: "100%", height: "43px" }}

                        />

                    </Row>
                    <Row>
                        {props.isActiveSearchByCarPlate && (
                            <InputComponent
                                xl={calcSizeByItems}
                                lg={4}
                                md={4}
                                sm={4}
                                xs={12}
                                type={"text"}
                                style={{ width: "100%", height: "43px" }}
                                label={intl.formatMessage({ id: "UpdateClientComponent.Content.CarPlate" })}
                                value={props.equipmentCarPlate} readOnly={true} />
                        )}

                        <InputComponent
                            xl={calcSizeByItems}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            type={"text"}
                            style={{ width: "100%", height: "43px" }}
                            label={intl.formatMessage({ id: "UpdateClientComponent.Content.SerialNumber" })}
                            value={props.equipmentSerialNumber} readOnly={true} />

                        <InputComponent
                            xl={calcSizeByItems}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            type={"text"}
                            style={{ width: "100%", height: "43px" }}
                            label={intl.formatMessage({ id: "UpdateClientComponent.Content.Brand" })}
                            value={props.equipmentBrand} readOnly={true} />

                        <InputComponent
                            xl={calcSizeByItems}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            type={"text"}
                            style={{ width: "100%", height: "43px" }}
                            label={intl.formatMessage({ id: "UpdateClientComponent.Content.Model" })}
                            value={props.equipmentModel} readOnly={true} />
                    </Row>
                    {isClientOwner === false &&
                        (<Row>
                            <label style={{ color: "red", fontSize: "12px", marginLeft: "10px" }}>
                                {intl.formatMessage({ id: "UpdateClientComponent.Content.ClientNotOwner" })}
                            </label>
                        </Row>)
                    }
                </DialogContent>
                <DialogActions className="loginbuttons">
                    <div style={{ display: "flex", justifyContent: "space-between", margin: "10px", paddingLeft: "5px" }}>
                        <Col md={6} sm={6} xs={6} lg={6}>
                            <ButtonComponent
                                onClick={updateClient}
                                className="enteraccount"
                                style={{ width: "97%", borderRadius: "5px" }}
                                text={intl.formatMessage({ id: "UpdateClientComponent.Action.Change" })}
                                loading={isEditButtonLoading}
                            />
                        </Col>
                        <Col md={6} sm={6} xs={6} lg={6}>
                            <ButtonComponent
                                onClick={() => setIsOpen(false)}
                                className="enteraccount"
                                style={{ width: "97%", borderRadius: "5px" }}
                                text={intl.formatMessage({ id: "UpdateClientComponent.Action.Cancel" })}
                            />
                        </Col>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    );
}
